import { Table, Button, Space, Tag, Flex, message, Popconfirm, notification } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { EditOutlined, PauseOutlined, DeleteOutlined, InfoOutlined, CheckCircleOutlined, StopOutlined, InboxOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import WorkflowManagementAPI from '../../../restAPI/WorkflowManagementAPI';
import CommonSkeletonLoader from '../../../helperComponents/CommonSkeleton';
// import { useNavigate } from "react-router-dom";

export default function Inprogress({ tabValue, searchText }) {
    //console.log(searchText)
    const tabKey = 1;

    const [payload, setPayload] = useState([]);
    const [isStateChanged, setIsStateChanged] = useState(false);
    const [currentCompanyInfo, setCurrentCompanyInfo] = useState({})
    const [messageApi, contextHolder] = message.useMessage();
    const [showPopconfirm, setShowPopconfirm] = useState(false);
    const [isInProgressListLoading, setIsInProgressListLoading] = useState(false);
    const [tempInprogressData, setTempInprogressData] = useState([]);

    //const [userRole, setUserRole] = useState();
    const navigate = useNavigate(); // Initialize the useNavigate hook
    const { companyId, token, userId, userCompany } = useSelector(state => state.auth);

    const [api, contextHolder2] = notification.useNotification();

    const openNotificationWithIcon = (type, message, description, placement) => {

        console.log(type, message, description, placement)
        // api[type]({
        //     message: message,
        //     description: description,
        //     placement
        // });
    };

    useEffect(() => {
        setIsInProgressListLoading(true);
        getApprovalRequestsData();
    }, [companyId, tabValue]);

    useEffect(() => {
        getApprovalRequestsData();
    }, [ isStateChanged]);

    const columns = [
        {
            title: 'Circulated On',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text) => {
                const date = new Date(text);
                const dateString = date.toLocaleDateString(); 
                const timeString = date.toLocaleTimeString(); 
                return (
                    <span>
                        {dateString}
                        <br />
                        {timeString}
                    </span>
                );
            },
        },
        {
            title: 'Initiator',
            dataIndex: ['createdBy', 'name'],
            //key: ['createdBy','name'],
        },
        {
            title: 'Subject Line',
            dataIndex: 'subject',
            //key: 'subject',
        },
        {
            title: 'Request Type',
            dataIndex: ['requestType', 'requestType'],
            //key: 'requestType',
        },
        {
            title: 'Circulation Type',
            key: 'circulationType',
            align: 'center',
            render: (_, record) => (
                <Space size="middle">
                    {record.circulationType === 'hierarchy' && <Tag color="success"> Hierarchical </Tag>}
                    {record.circulationType === 'parallel' && <Tag color="warning"> Parellel </Tag>}
                </Space>
            ),
        },
        {
            title: 'Status',
            key: 'approvalStatus',
            align: 'center',
            // fixed: 'right',
            render: (_, record) => (
                <Space size="middle">
                    {record.approvalStatus === 'rejected' && <Tag color="error"> Rejected </Tag>}
                    {record.approvalStatus === 'pending' && <Tag color="warning"> Pending </Tag>}
                    {record.approvalStatus === 'completed' && <Tag color="yellow"> Completed </Tag>}
                </Space>
            ),
        },
        {
            title: 'Action',
            key: 'actionButtons',
            align: 'center',
            width: 150,
            render: (_, record) => (
                <Flex align='center' gap={16}>
                    <Button icon={<EditOutlined />} onClick={()=>{navigate('/work-flow/edit-approval-request', { state: record }); console.log(record,"recordsdssdsdsdsdfdafdshj")}} style={{ display: editButton(record) ? 'inline-block' : 'none' }} type="default" title='Edit' />

                    <Popconfirm
                        title="Archive"
                        description="Are you sure you wish to archive this?"
                        onConfirm={() => onClickArchiveButton(record._id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button icon={<InboxOutlined />}
                            //onClick={() => onClickArchiveButton(record._id)} 
                            //style={{ display: archiveButton(record) ? 'inline-block' : 'none' }} visible to all users
                            type="default" title='Archvied' />
                    </Popconfirm>

                    <Popconfirm
                        title="Delete"
                        description="Are you sure you wish to delete this?"
                        onConfirm={() => onClickDeleteButton(record._id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button icon={<DeleteOutlined />} 
                            //onClick={() => onClickDeleteButton(record._id)} 
                            style={{ display: deleteButton(record) ? 'inline-block' : 'none' }} danger type="default" title='Delete' />
                    </Popconfirm>

                </Flex>
            ),
        },
    ];

    function getApproverIdMatchingParentID(param1, list){
        for (const element of list) {
            if(element['_id'] == param1){
                if(element['permission'] == 'view'){
                    return false
                }
            }
        }
        return true
    }

    const getApprovalRequestsData = async () => {
        var userRole = 0;
        const companyInfo = userCompany.companyData.find(company => company.companyId === companyId);
        await WorkflowManagementAPI.getApprovalRequests(tabKey, companyId, token).then((res) => {
            setCurrentCompanyInfo(companyInfo);

            var dataList = res.data
            dataList.forEach(element => {
                let changeDate = new Date(element['createdAt']).toLocaleString()
                element['createdAt'] = changeDate
                element['approvers'].forEach(elementApprover => {

                    if (elementApprover['approverResponseTime'] != null) {
                        let changeDateApprover = new Date(elementApprover['approverResponseTime']).toLocaleString()
                        elementApprover['approverResponseTime'] = changeDateApprover
                    }

                    if (elementApprover['hockResponseTime'] != null) {
                        let changeDateApprover = new Date(elementApprover['hockResponseTime']).toLocaleString()
                        elementApprover['hockResponseTime'] = changeDateApprover
                    }
                });
                
                if (companyInfo['userDetailsId'] == element['createdBy']['_id']) {
                    userRole = 1;   //Initiator
                }
                else {
                    if (getApproverIdMatchingParentID(element['parentEntryId'], element['approvers'])) {
                        userRole = 2; //Approver
                    } else {
                        userRole = 3; //Viewer
                    }
                }

                //userRole = 1
                element["userRole"] = userRole;
                element["tabKey"] = tabKey;
                //console.log(element)
            });
            setPayload(dataList)
            setTempInprogressData(dataList)
            setIsInProgressListLoading(false);
        }).catch((err) => {
            setIsInProgressListLoading(false);
            console.log("Error getting ApprovalRequestsData :", err.message);
        }).finally(() => {

        })
    };

    function editButton(data) {
        //return true
        //1
        if (data['userRole'] == 1) {
            return true;
        }else {
            return false;
        }
    }

    function deleteButton(data) {
        //return true
        //1
        if (data['userRole'] == 1) {
            return true;
        } else {
            return false;
        }
    }

    const handleRowClick = (record, cell) => {
        if (cell == null || cell == undefined) {
        } else {
            if (cell.cellIndex === 6) {
            } else {
                if (record['userRole'] == 1) {
                    navigate('/work-flow/initiator-view', { state: { objectDataToInitiatorView: record } })
                } else {
                    // navigate('/work-flow/view-circuler', { state: { objectDataToFullCirculerView: record } })
                    navigate('/work-flow/view-circuler', { state: { tabValue: tabValue, approvalId: record._id } })
                }
            }
        }

    };

    const onClickArchiveButton = async (data) => {
        setIsStateChanged(false)

        var formData = {
            "action": "archive"
        }
        await WorkflowManagementAPI.setArchiveUnarchive(data, formData, companyId, token).then((res) => {
            setIsStateChanged(true)
            message.success('Added to Archived');
            openNotificationWithIcon('success', 'Success', `Added to Archived`, 'bottomLeft');
        })
    }

    const onClickDeleteButton = async (data) => {
        setIsStateChanged(false)

        try {
            await WorkflowManagementAPI.deleteApprovalRequest(data, companyId, token).then((res) => {
                setIsStateChanged(true)
            })
        } catch (err) {
            messageApi.open({
                type: 'error',
                content: err.message,
            });
        }

    }

    useEffect(() => {
        handleSearchFunction(searchText)
    }, [searchText])

    const handleSearchFunction = (value) => {
        if (value) {
            const filteredData = payload.filter(item =>
                item.subject.toLowerCase().includes(value.toLowerCase()) ||
                item.createdBy.name.toLowerCase().includes(value.toLowerCase()) ||
                item.requestType.requestType.toLowerCase().includes(value.toLowerCase())
            );
            setTempInprogressData(filteredData);
        } else {
            setTempInprogressData(payload)
        }
    }

    return (
        <>
            <>
                {contextHolder}
            </>
            <>
                {contextHolder2}
            </>
            <>
                {
                    isInProgressListLoading ? (<>
                        <CommonSkeletonLoader itemCount={2} />
                    </>) : (<>
                        <Table
                            //dataSource={dataSource}
                            //dataSource={payload}
                            dataSource={tempInprogressData}
                            columns={columns}
                            //pagination={false}
                            onRow={(record) => ({
                                onClick: (e) => {
                                    const cell = e.target.closest('td');
                                    handleRowClick(record, cell);
                                } // Redirect on row click
                            })}
                            rowClassName="clickable-row" // Optional: Add custom styling for clickable rows
                            style={{
                                cursor: 'pointer', // Ensures rows appear clickable
                            }}
                        />
                    </>)
                }
            </>
        </>


    );
}
